import * as React from 'react'
import type {SVGProps} from 'react'
const SvgWallet = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        id="wallet_svg__Layer_1"
        x={0}
        y={0}
        viewBox="0 0 116 101"
        {...props}
    >
        <style>{'.wallet_svg__st0{fill:#142745}'}</style>
        <path
            d="M108.3 43.6v-16c0-2.1-1.7-3.8-3.8-3.8H92.8v-20c0-1.1-.5-2.2-1.3-2.9s-2-1-3-.8l-78 13C4.5 13.6 0 18.6 0 24.5v65C0 95.8 5.2 101 11.5 101h93c2.1 0 3.8-1.7 3.8-3.8v-20c4.6-1.6 7.7-5.9 7.7-10.9V54.7c0-2.7 0-9.5-7.7-11.1M7.6 23.9c.3-1.8 1.7-3.2 3.6-3.3h.3L85.2 8.2v15.7zm93.1 23.2H81.2c-8.5 0-15.4 6.9-15.4 15.4s6.9 15.4 15.4 15.4h19.5v15.7H11.5c-2.2 0-4-1.8-4-4V31.4h93.2v15.7m-19.5 7.5h19.4c2.8 0 5.2-1.3 6.5-3.6 1.3.4 1.3 1.3 1.3 3.7v11.6c0 2.2-1.8 4-4 4H81.2c-4.3 0-7.9-3.5-7.9-7.8s3.6-7.9 7.9-7.9"
            className="wallet_svg__st0"
        />
        <circle cx={83} cy={63} r={5} className="wallet_svg__st0" />
    </svg>
)
export default SvgWallet
